import type { ReactElement, ReactNode } from 'react';

import { FormControl } from '@frontend/components';

import { HorizontalFormField } from './HorizontalFormField';
import { HorizontalFormLabel } from './HorizontalFormLabel';

export type HorizontalFormControlProps = {
  children: ReactElement;
  label?: ReactNode;
};

export const HorizontalFormControl = ({
  label,
  children,
}: HorizontalFormControlProps) => (
  <FormControl
    display="flex"
    gap={1.5}
    alignItems="center"
    minW="500px"
    maxW="100%"
  >
    {label ? (
      <HorizontalFormLabel w="110px">{label}</HorizontalFormLabel>
    ) : null}
    <HorizontalFormField minW={0}>{children}</HorizontalFormField>
  </FormControl>
);
